export default __webpack_public_path__ + "static/media/stampedHolo.463c1456.svg";